export default __webpack_public_path__ + "static/media/ghost-red-980x980.2040c700.png";